<script>
import { createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();

/**
 * props
 */
export let label;
export let group;
export let val;
export let current;

/**
 * onclick event handler
 * @param e
 */
function handleClick(e) {
  dispatch('filterItem', {
    group: group,
    val: val
  });
}
</script>

<button
  on:click={handleClick}
  class="{current === val ? 'flagged' : ''}"
>
  {label}
</button>

<style>
button {
  margin: 0 0 12px 0;
  padding: 2px 12px 2px 12px;
  background: 4px 0px white no-repeat;
  border: 1px solid #CFD4D9;
  border-radius: 16px;
  font-size: 0.875rem;
  color: #606060;
}
button.flagged {
  background: #CFD4D9;
}
</style>